export default __webpack_public_path__ + "static/Sticker_A5_USERS_CY_EN-67dfc0c299ee131aff224f23c1cadc8d.svg";